import React from 'react';
import './Cart.css';

function Cart({ cart, onUpdateQuantity, onRemove, onOrder, onClose, totalPrice }) {
  if (cart.length === 0) {
    return (
      <div className="cart-container">
        <div className="cart-header">
          <h2>Корзина</h2>
          <button className="close-button" onClick={onClose}>✕</button>
        </div>
        <div className="empty-cart">
          <p>Корзина пуста</p>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-container">
      <div className="cart-header">
        <h2>Корзина</h2>
        <button className="close-button" onClick={onClose}>✕</button>
      </div>
      
      <div className="cart-items">
        {cart.map(item => (
          <div key={item.id} className="cart-item">
            {item.image_url && (
              <div className="cart-item-image">
                <img 
                  src={item.image_url} 
                  alt={item.name}
                  onError={(e) => {
                    console.error('Ошибка загрузки изображения:', item.image_url);
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            )}
            <div className="cart-item-content">
              <div className="cart-item-main">
                <div className="cart-item-info">
                  <h4 className="cart-item-name">{item.name}</h4>
                  <p className="cart-item-price">{item.price} ₽</p>
                </div>
                <div className="cart-item-controls">
                  <button
                    className="quantity-button minus"
                    onClick={() => onUpdateQuantity(item.id, item.quantity - 1)}
                    aria-label="Уменьшить количество"
                  >
                    −
                  </button>
                  <input
                    type="number"
                    className="quantity-display"
                    value={item.quantity}
                    min="1"
                    onChange={(e) => {
                      const newQuantity = parseInt(e.target.value) || 1;
                      if (newQuantity >= 1) {
                        onUpdateQuantity(item.id, newQuantity);
                      }
                    }}
                    onBlur={(e) => {
                      const newQuantity = parseInt(e.target.value) || 1;
                      if (newQuantity < 1) {
                        onUpdateQuantity(item.id, 1);
                      }
                    }}
                    aria-label="Количество товара"
                  />
                  <button
                    className="quantity-button plus"
                    onClick={() => onUpdateQuantity(item.id, item.quantity + 1)}
                    aria-label="Увеличить количество"
                  >
                    +
                  </button>
                </div>
                <button
                  className="remove-button"
                  onClick={() => onRemove(item.id)}
                >
                  Удалить
                </button>
              </div>
              <div className="cart-item-total-row">
                <div className="cart-item-total">
                  {(item.price * item.quantity).toFixed(2)} ₽
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="cart-footer">
        <div className="cart-total">
          <span className="total-label">Итого:</span>
          <span className="total-price">{totalPrice.toFixed(2)} ₽</span>
        </div>
        <button className="order-button" onClick={onOrder}>
          Оформить заказ
        </button>
      </div>
    </div>
  );
}

export default Cart;

